import { intlLocale } from 'kanban/constants';

// vue-datepicker-next only ships English by default; the names for any other locale come
// from Intl so no extra dependency is needed. 2023-01-01 is a Sunday.
const names = (locale, options, unit, count) =>
  Array.from({ length: count }, (_, index) => {
    const date =
      unit === 'month'
        ? new Date(2023, index, 1)
        : new Date(2023, 0, 1 + index);
    const key = unit === 'month' ? 'month' : 'weekday';
    return new Intl.DateTimeFormat(locale, { [key]: options }).format(date);
  });

export const buildDatePickerLang = appLocale => {
  const locale = intlLocale(appLocale) || 'en';
  return {
    formatLocale: {
      months: names(locale, 'long', 'month', 12),
      monthsShort: names(locale, 'short', 'month', 12),
      weekdays: names(locale, 'long', 'weekday', 7),
      weekdaysShort: names(locale, 'short', 'weekday', 7),
      weekdaysMin: names(locale, 'narrow', 'weekday', 7),
      firstDayOfWeek: 0,
    },
    yearFormat: 'YYYY',
    monthFormat: 'MMMM',
    monthBeforeYear: true,
  };
};
